var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCulture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3327 5.66667C49.1105 0 33.9994 0 33.9994 0C33.9994 0 18.8883 0 5.66607 5.66667C-0.00060153 34 5.66607 58.5556 33.9994 68C62.3327 58.5556 67.9994 34 62.3327 5.66667Z",
    fill: "#CCD6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 64.0032C12.1118 56.1548 3.70438 37.4586 8.99138 8.39428C20.897 3.83261 33.8643 3.77783 34.0003 3.77783C34.1344 3.77783 47.1432 3.85339 59.0092 8.39428C64.2962 37.4586 55.8887 56.1548 34.0003 64.0032Z",
    fill: "#55ACEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0089 8.39428C47.1429 3.85339 34.1341 3.77783 34 3.77783V64.0032C55.8884 56.1548 64.2959 37.4586 59.0089 8.39428Z",
    fill: "#226699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCulture);
export default __webpack_public_path__ + "static/media/shield-culture.3ed40f8ce0c296624f38df87525158f6.svg";
export { ForwardRef as ReactComponent };